import React, {useEffect, useState} from 'react';
import { Table } from 'antd';
import {Redirect} from "react-router-dom";


const UsersTable = ({imba_id, dataSource, columns}) => {
    const[loading, setLoading] = useState(true)
    const [choose, setChoose] = useState(false)

    useEffect(() => {
        //setLoading(false)
        if (dataSource)
            setLoading(false);
    }, [dataSource])
    return choose ? (
        <Redirect to = {{ pathname: `/${imba_id}/user/${choose}` }} />
    ) : (
        <Table columns={columns} pagination={false} dataSource={dataSource} loading={loading} rowClassName={'imbachat-table-row'}
        onRow={
            (record, index) => {
                return {
                    onClick: event => {
                        console.log(event.target)
                        let ban_btn = ""
                        if (document.getElementById(`ban-${record.id}`))  ban_btn = document.getElementById(`ban-${record.id}`)
                        if (document.getElementById(`ban-${record.id}`) && !ban_btn.contains(event.target))
                        {
                            if(event.target.outerText != "Complete" && event.target.outerText != "Break" && event.target.outerText != "unban user" && event.target.outerText != "ban user" && event.target.outerText != "Delete user" && event.target.outerText != "Restore user" && !event.target.id.includes('rc_select') && !(event.target.outerText == "1h" || event.target.outerText == "30m" || event.target.outerText == "24h" || event.target.outerText == "1 week" || event.target.outerText == "forever") && event.target.outerText != "OK"){
                                setChoose(record.remote_user_id)
                            }
                        }
                    }
                }
            }
        }/>
    )
}
export default UsersTable;